import React, { useEffect, useState, useCallback } from "react";
import Button from "../Common/CprimeButton";
import CubeAuthVersionList from "./CubeAuthVersionList";
import * as style from "./ManageCubeAuthVersion.module.scss";
import { base64PrivateKey, getEnv } from "../../Constants/env";
import { useIdToken } from "../../hooks/useAuthSession";
import axios from "axios";
import { decodePolicyData } from "../../utils/commonUtil";

interface ManageCubeAuthVersionProps {
  appId?: number;
  appName?: string;
  isAccessible?: boolean;
}

const ManageCubeAuthVersion: React.FC<ManageCubeAuthVersionProps> = ({
  appId = 0,
  appName = "All Applications",
  isAccessible = true,
}) => {
  const scssClass = style as any;
  const [isCreateVersion, setIsCreateVersion] = useState(false);
  const [canEditVersion, setCanEditVersion] = useState(false);
  const idToken = useIdToken();

  const checkCubeAuthEditPermission = useCallback(async () => {
    if (!idToken) return false;
    try {
      const { data, status } = await axios.get("/v1/roleconsumption/policy", {
        baseURL: getEnv()?.baseURL,
        headers: { Authorization: idToken },
      });
      if (status !== 200) return false;

      const decodeData = decodePolicyData(data?.data, base64PrivateKey);
      const accessList = Array.isArray(decodeData)
        ? decodeData.flatMap((item: any) => item?.Access ?? [])
        : (decodeData?.Access ?? []);

      return accessList.some((access: any) =>
        (access?.feature ?? []).some(
          (feature: any) =>
            feature?.FeatureName === "CubeAuth Version Management" &&
            feature?.FeaturePermission?.some(
              (permission: any) => permission?.Permission === "Edit",
            ),
        ),
      );
    } catch {
      return false;
    }
  }, [idToken]);

  useEffect(() => {
    let isMounted = true;
    checkCubeAuthEditPermission().then((result) => {
      if (isMounted) setCanEditVersion(result);
    });
    return () => {
      isMounted = false;
    };
  }, [checkCubeAuthEditPermission]);

  return (
    <div className={scssClass.container}>
      <div className={scssClass.header}>
        <div className={scssClass.title}>Cube Auth Version Management</div>
        <Button
          variant="tertiary"
          size="medium"
          disabled={!canEditVersion}
          onClick={() => setIsCreateVersion(true)}
        >
          Create New Version
        </Button>
      </div>
      <CubeAuthVersionList
        appId={appId}
        appName={appName}
        isAccessible={isAccessible}
        isPageView={true}
        canEditVersion={canEditVersion}
        isCreateVersion={isCreateVersion}
        setIsCreateVersion={setIsCreateVersion}
      />
    </div>
  );
};

export default ManageCubeAuthVersion;
